<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="active"
      style="background:transparent"
    >
      <!-- Payment-->
      <v-tab-item>
        <v-autocomplete
          v-model="paymentReport"
          label="Report Types"
          :items="paymentReports"
          item-text="name"
          class="pt-5 px-3"
          style="background:white"
          autofocus
        />

        <payroll-report-export-to-bank
          v-if="paymentReport === 'Export To Bank'"
          class="mb-2"
        />
        <lhdn
          v-if="paymentReport === 'EPF Form A / EIS Import / SOCSO Import / CP39 / RHB Import'"
          class="mb-2"
        />
        <payment-summary
          v-if="paymentReport === 'Payment Summary'"
          class="mb-2"
        />
        <payroll-bank-credit-detail-report
          v-if="paymentReport === 'Payment Bank Credit Details Report'"
          class="mb-2"
        />
      </v-tab-item>
    </v-tabs-items>
    <!-- -->
  </div>
</template>

<script>
  export default {
    components: {
      PayrollReportExportToBank: () => import('@/components/hris/payroll/report/ExportToBank'),
      Lhdn: () => import('@/components/hris/payroll/report/Lhdn'),
      PaymentSummary: () => import('@/components/hris/payroll/report/PaymentSummary'),
      PayrollBankCreditDetailReport: () => import('@/components/hris/payroll/report/PayrollBankCreditDetailReport'),
    },

    data () {
      return {
        tabItems: [
          { name: 'Payment' },
        ],
        active: 0,

        paymentReport: null,
        paymentReports: [
          { name: 'Export To Bank' },
          { name: 'EPF Form A / EIS Import / SOCSO Import / CP39 / RHB Import' },
          { name: 'Payment Summary' },
          { name: 'Payment Bank Credit Details Report' },
        ],
      }
    },
  }
</script>
